import dayjs from 'dayjs';
import { UseQueryOptions } from 'react-query';
import { MessagesTypes } from '.';

const validateDate = (value?: string) => !!value && dayjs(value).isValid();

const validateRange = (range?: [string, string]) => {
  if (!range) return true;
  const [start, end] = range;
  return validateDate(start) && validateDate(end);
};

export const validateFilters = (filters: MessagesTypes.Filters) =>
  validateRange(filters.appointmentDate) && validateRange(filters.recallDate);

export const validateQueryEnabledWithDefault = (
  defaultCondition: boolean,
  enabledOption?: UseQueryOptions['enabled']
) => {
  if (enabledOption === undefined) return defaultCondition;
  return defaultCondition && enabledOption;
};

export const formatPhoneWithCountryCode = (personPhone: string) => {
  if (!personPhone) return personPhone;

  if (personPhone.startsWith('+')) {
    return personPhone;
  }

  if (personPhone.startsWith('1')) {
    return `+${personPhone}`;
  }

  return `+1${personPhone}`;
};
